export default "__VITE_ASSET__w6s3js4___"